
export default {
  props: {
    promotion: {
      type: Object,
      default: null
    },
    product: {
      type: Object,
      default: null
    }
  },
  vessel: {
    image: {
      width: 'md',
      height: 'md',
      overflow: 'hidden',
      borderRadius: true,
      shadow: true,
      borderWidth: 1
    }
  },
  computed: {
    title() {
      return {
        tag: 'h2',
        html: this.promotion.name,
        fontSize: {
          all: 'xl',
          lg: '2xl'
        }
      }
    },
    text() {
      return {
        html: this.promotion.excerpt,
        fontWeight: 'light'
      }
    },
    image() {
      return {
        fit: 'cover',
        ratio: { all: '16/9', lg: '4/3' },
        height: 'auto',
        borderWidth: 1,
        borderRadius: true,
        backgroundColor: 'white',
        overflow: 'hidden',
        ...this.product.image
      }
    },
    visibleImages() {
      return this.$screen.lg ? 5 : 4
    },
    images() {
      return this.product.images.slice(0, this.visibleImages)
    },
    detailsLink() {
      const products = this.$pagePath('products')
      return `${products}/${this.product.slug}`
    }
  }
}
